import Vue from 'vue';
import axios from 'axios';
import DxTreeView from 'devextreme-vue/tree-view';
import { isNullOrEmptyString } from '@devexpress/analytics-core/analytics-internal';

export default {
  name: 'hierarchyLinks',
  components: {
    DxTreeView,
  },
  props: {
    onNodeSelected: {
      type: Function
    },
    onNodeClickedFunName: {
      type: String
    },
    parentComp: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      treeFilter: '',
      searchedItems: [],
      searchingDone: false,
      selectedItems: [],
      isContentReady: false,


      treeItems: [],
      dataSource: [],
      pageSize: 50,
      skip: 0,
      hasChildrenExpr: 'hasChildren',
      savedScrollTop: 0,
      iCurrentCount: 0
    };
  },
  created() {
    
  },
  methods: {
    getUniqueId() {
      return this.iCurrentCount++;
    },
    onContentReady(e) {
      if (!this.dataSource.length) {
        this.loadItems();
      }
    },
    loadItems() {
      axios.get('Element/GetHierarchyLinks?elementTypeId=-1')
        .then(async response => {
          this.dataSource = response.data;

          const newData = this.dataSource.slice(this.skip, this.skip + this.pageSize);

          //this.treeItems = [...this.treeItems, ...newData];

          for (let i = 0; i < (newData.length); i++) {
            this.treeItems = [...this.treeItems, newData[i]];
            await this.sleep(1);
          }

          this.skip += this.pageSize;
          this.isContentReady = true;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sleep(tm: number): Promise<void> {
      return new Promise<void>((resolve) => {
        setTimeout(resolve, tm)
      })
    },
    loadItemsOnScroll() {
      this.savedScrollTop = this.$refs.scrollContainer.scrollTop;

      const newData = this.dataSource.slice(this.skip, this.skip + this.pageSize);
      this.treeItems = [...this.treeItems, ...newData];
      this.skip += this.pageSize;

      this.$nextTick(() => {
        this.$refs.scrollContainer.scrollTop = this.savedScrollTop;
      });
    },
    handleScroll() {
      const scrollContainer = this.$refs.scrollContainer;
      const scrollHeight = scrollContainer.scrollHeight;
      const scrollTop = scrollContainer.scrollTop;
      const containerHeight = scrollContainer.clientHeight;

      if (scrollTop + containerHeight + 32 >= scrollHeight) {
        this.loadItemsOnScroll();

      }
    },

    nodeClicked(node) {
      if (node.event === undefined) return;

      if (!isNullOrEmptyString(this.onNodeClickedFunName)) {
        if (this.parentComp)
          this.parentComp[this.onNodeClickedFunName](node.itemData);
        else
          this.$parent[this.onNodeClickedFunName](node.itemData);
      }
    },
    async searchOnTree() {
      if (isNullOrEmptyString(this.treeFilter)) {
        this.searchingDone = false;
        return;
      }

      this.searchedItems = [];

      this.searchingDone = true;

      for (var i = 0; i < this.dataSource.length; i++) {
        if (!isNullOrEmptyString(this.dataSource[i].Name)) {
          if (this.dataSource[i].Name.toUpperCase().includes(this.treeFilter.toUpperCase())) {
            this.searchedItems.push(this.dataSource[i]);
              await this.sleep(1);
          }
        }
      }      
    },
    initSelected(itemId) {
      this.treeView.unselectAll();
      this.treeView.collapseAll();

      this.treeView.selectItem(itemId);
      this.treeView.expandItem(itemId);
    },
    clearSelection() {
      this.treeView.unselectAll();
      this.treeView.collapseAll();
    }
  }
}
